var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlockFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 6.926 9.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_503",
    "data-name": "\\u7EC4 503",
    transform: "translate(-3284.788 -640.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_38",
    "data-name": "\\u8DEF\\u5F84 38",
    d: "M3285.275,649.778a.577.577,0,0,1-.417-.312.768.768,0,0,1-.067-.294q-.006-1.7,0-3.408a.572.572,0,0,1,.6-.6h.171v-.114c0-.64-.005-1.28.006-1.92a2.537,2.537,0,0,1,.806-1.811,2.565,2.565,0,0,1,1.372-.725,2.7,2.7,0,0,1,3,1.606,2.472,2.472,0,0,1,.2,1.044.368.368,0,0,1-.334.373,2.922,2.922,0,0,1-.477,0,.36.36,0,0,1-.334-.334,2.347,2.347,0,0,0-.1-.583,1.541,1.541,0,0,0-2.948.208,1.856,1.856,0,0,0-.033.34c0,.619,0,1.238,0,1.857,0,.015,0,.03,0,.058h.1q2.131,0,4.264,0a.578.578,0,0,1,.566.326.657.657,0,0,1,.059.269q0,1.713,0,3.426a.571.571,0,0,1-.445.581c-.014,0-.028.011-.042.016Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockFilled);
export default __webpack_public_path__ + "static/media/unlock_filled.387ee9cd.svg";
export { ForwardRef as ReactComponent };